import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { appInitializer } from './helpers/app.initializer';

export const coreProviders = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return appInitializer(authService)();
    }),
  ];
};
